module.exports = __webpack_public_path__ + "static/media/Experimental.55fe63a4.png";